import React from 'react';
import Badge from './Badge';
import Feature from './Feature';

const Home = () => {
	return(
		<div className="main__content">
			<Badge />
			<Feature />
		</div>
	);
}

export default Home;